import * as React from "react";
import { CorrectionItem } from "../CorrectionItem";

/**
 * This is the entry in the list of DCFs that will be available to the user.
 */
export const MediaSerialItem = ({ recordId, isDisabled, onClick, onRemove, correctionSelected }): JSX.Element => {
    return (
        <CorrectionItem
                recordId={recordId}
                title="Change Card Serial Number"
                description="Change card serial number for a cough session"
                isDisabled={isDisabled}
                onClick={onClick}
                onRemove={onRemove}
                correctionSelected={correctionSelected}
            />
    );
}
